<template>
    <section class="CTAButton ContentSection ContentSection--hasclippath">
        <h5 v-html="properties.title"></h5>
        <div class="CTAButton__subtitle" v-html="properties.subtitle"></div>
        <div class="CTAButton__buttonwrapper">

            <router-link class="Button" v-if="properties.buttonLink.length > 0 && properties.buttonLink[0].internalLink !== null" 
                :to="getRouteFromID(properties.buttonLink[0].internalLink)" :style="getButtonColor" v-html="properties.buttonLink[0].linkText"></router-link>
            <a class="Button" v-else-if="properties.buttonLink.length > 0 && properties.buttonLink[0].linkUrl !== ''" 
                :href="properties.buttonLink[0].linkUrl" :style="getButtonColor" v-html="properties.buttonLink[0].linkText" target="_blank" @click="trackExternalLink(properties.buttonLink[0].linkUrl)"></a>
        </div>
    </section>
</template>
<script>
export default {
    props: ["properties", "pageData"],
    methods: {
        getRouteFromID(id) {
            return app.manifest.getRouteFromID(id);
        },
        trackExternalLink(url) {
            // _paq.push(["trackEvent", "external-link", window.app.vm.$route.path, url]);
        }
    },
    computed: {
        getButtonColor() {
            return {
                'background-color': this.pageData.color
            }
        }
    }
}
</script>
<style lang="scss">
@import '@/assets/sass/_responsiveness.scss';

.CTAButton {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 120px;
    padding-bottom: 40px;
    background: #fff;

    text-align: left;

    h5 {
        margin-bottom: 20px;
    }

    .CTAButton__subtitle {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        margin-bottom: 50px;
    }

    .CTAButton__buttonwrapper {
        width: 100%;
        max-width: var(--content-max-width);
        padding: var(--content-padding);

        a {
            color: #fff;
        }
    }


    @include mobile-only {
        padding-top: 80px;
    }
}
</style>